var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/directives/repeat.js", "lit/directives/class-map.js", "lit/decorators.js", "@lit/context", "./app-context", "underscore", "./chat-message", "./chat-userinput", "./app", "./custom-element-registry", "utils/resizer", "./utils/theme", "../../../apps/src/js/api/v2/models/answer", "./utils", "i18n/i18n"], function (require, exports, lit_1, repeat_js_1, class_map_js_1, decorators_js_1, context_1, app_context_1, _, chat_message_1, chat_userinput_1, app_1, custom_element_registry_1, resizer_1, theme_1, answer_1, utils_1, i18n_1) {
    "use strict";
    var _a, _b, _c, _d, _e, _f, _g;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ChatElement = exports.ChatActionsElement = exports.ChatViewElement = exports.objConverter = exports.booleanAttributeConverter = void 0;
    exports.booleanProperty = booleanProperty;
    _ = __importStar(_);
    resizer_1 = __importDefault(resizer_1);
    i18n_1 = __importDefault(i18n_1);
    function getDefaultChannel(application) {
        return application.channels.at(0);
    }
    function getDefaulChannelBaseUrl(application) {
        return application.channels.at(0).get("url") + "../../api/chat/v1beta";
    }
    exports.booleanAttributeConverter = {
        fromAttribute: (value) => value === 'true',
        toAttribute: (value) => (value ? 'true' : 'false'),
    };
    function booleanProperty(options = {}) {
        return (0, decorators_js_1.property)(Object.assign({ type: Boolean, converter: exports.booleanAttributeConverter }, options));
    }
    exports.objConverter = {
        toAttribute: (obj) => {
            return JSON.stringify(obj);
        },
        fromAttribute: (value) => {
            try {
                return JSON.parse(`${value}`);
            }
            catch (_a) {
                return null;
            }
        }
    };
    class ChatViewElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.messagesHeight = 0;
        }
        static get styles() {
            // TODO import other variables from the theme descriptior
            //      also theme variables should be prefixed? e.g. mb-color-...
            return (0, lit_1.css) `
          :host {
             color: var(--mindbreeze-colors-primary);
             display: flex;
             flex-direction: column;
             height: 100vh;
          }

          .actions {
            position: relative;
          }

          .messages-scroll {
            flex: 1;
            min-height:10%;
            overflow: auto;
            display:flex;
          	-webkit-overflow-scrolling: touch;
            scroll-behavior: smooth;
          }

          .messages {
            display: flex;
            flex-direction: column;
            flex-grow:1;
            min-height: 100%;
            /* background: #eee; */
            min-width: 0;
            flex-shrink: 1;
          }
          .wrapper {
             display:flex;
             flex-direction: column;
             position: relative;
             height: 100%;
             width: 100%;          
             top: 0;
             left: 0;
          }
          .scroll-wrapper {
             position: absolute;
             scrollbar-width: thin;
             height: 100%;
             top: 0;
             left: 0;
             overflow-y: auto;
          }
          .input {
          }

          * {
            scrollbar-width: thin;
          }
          .view{
            height:100% !important;
            display: flex;
            flex-direction: column;
            overflow:hidden;
          }
          .view .messages-scroll{
            flex-grow: 1;
          }

          
    `;
        }
        render() {
            return (0, lit_1.html) `
        <div class="view">
          <div class="actions"><slot name="actions"></slot></div>              
            <div class="space"></div>
            <div class="messages-scroll">
                <div class="messages">
                    <slot name="messages"></slot>
                </div>
            </div>
            <div class="input">
                <slot name="input"></slot>
            </div>
        </div>
    `;
        }
    }
    exports.ChatViewElement = ChatViewElement;
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Object)
    ], ChatViewElement.prototype, "messagesHeight", void 0);
    class ChatActionsElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.displayCreateConv = true;
            this.createConvBtnHovered = false;
        }
        static get styles() {
            return (0, lit_1.css) `
    :host(.chat-action-container.full-width) {
      position: sticky;
      top: 0;
      width: 100%;
      background: white;
      top: 0;
      left: 0;
    }
    :host(.chat-action-container) {
      display: flex;
      flex-direction : row;
      gap: 8px;
      width: fit-content;
      min-width: 0px;
      align-items: center;
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 1;
    }

    :host(.chat-action-container) .action-item {
      display: flex;
      align-items: center;
    }

    .actions .btn-link {
      padding: 8px;
      color: #898888;
      cursor: pointer;
      background-color: var(--insight-chat-actions-button-passive-color);
      border: 1px solid var(--insight-chat-actions-button-border-color);
      border-radius:50%;
    }
    .actions .btn-link:hover,
    .actions .btn-link:active {
      background-color: var(--insight-chat-actions-button-clicked-color);
    }
    :host(.chat-action-container.full-width) .actions .btn-link {
      background-color: transparent;
      border: none;
    }

    .actions .reset-chat-btn-tooltip {
      display: none;
      font-weight: bold;
    }
    :host(.chat-action-container.full-width) .actions .reset-chat-btn-tooltip {
      display: inline;
      white-space: nowrap;
      line-height: 23px;
    }
    :host(.chat-action-container:not(.full-width)) .actions .action-item.button-hovered .reset-chat-btn-tooltip {
      display: inline;
      white-space: nowrap;
      color: var(--mindbreeze-colors-on-surface-container);
      background-color: var(--mindbreeze-colors-surface-container);
      border-radius: 10px;
      border: none;
      padding: 2px 12px 2px 12px;
      font-size: 12px;
      margin-left: 8px;
    }

    .actions a {
      text-decoration: none;
      font-weight: bold;
      color: var(--result-actions-color);
      cursor: pointer;
      font-family: var(--result-actions-font-family);
      font-size: var(--result-actions-font-size);
      font-weight: var(--result-actions-font-weight)
    }
    .actions .mb-icon  {
      height: 16px;
      width: 16px;
    }
  `;
        }
        onResetChat() {
            console.log("reset");
        }
        render() {
            var _a, _b, _c;
            const theme = this.themeDescriptor || {};
            const icons = theme.icons || {};
            const fontColor = (0, theme_1.resolveCssVarValue)((_c = (_b = (_a = theme.themes) === null || _a === void 0 ? void 0 : _a.base) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.outline, theme) || 'currentColor';
            const createNewIcon = (0, utils_1.renderIcon)(icons, 'pen-to-square', {
                color: fontColor,
                altText: (0, i18n_1.default)('create_new_conversation'),
            });
            let actions = [];
            if (this.displayCreateConv) {
                actions.push((0, lit_1.html) `
        <div class="action-item ${this.createConvBtnHovered ? "button-hovered" : ""}">
          <button @click=${this.startNewConversation} 
            class="btn btn-link mb-action-reset-chat-conversation"
            @mouseenter=${this._onCreateConvBtnEnter}
            @mouseleave=${this._onCreateConvBtnLeave}
          >
            ${createNewIcon}<span class="mb-acc"></span>
          </button>
                                        <!-- TODO: add translation -->
          <label class="reset-chat-btn-tooltip" @click=${this.startNewConversation}>${(0, i18n_1.default)('start_new_conversation')}</label> 
        </div>
        `);
            }
            return (0, lit_1.html) `<div class="actions">
          ${actions}
      </div>`;
        }
        startNewConversation() {
            this.createConvBtnHovered = false;
            this.dispatchEvent(new CustomEvent('action', {
                bubbles: true,
                composed: true,
                detail: { action: "createNewConversation" }
            }));
        }
        _onCreateConvBtnEnter() {
            this.createConvBtnHovered = true;
        }
        _onCreateConvBtnLeave() {
            this.createConvBtnHovered = false;
        }
    }
    exports.ChatActionsElement = ChatActionsElement;
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object)
    ], ChatActionsElement.prototype, "themeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_b = typeof Partial !== "undefined" && Partial) === "function" ? _b : Object)
    ], ChatActionsElement.prototype, "chatWidgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Boolean)
    ], ChatActionsElement.prototype, "displayCreateConv", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Boolean)
    ], ChatActionsElement.prototype, "createConvBtnHovered", void 0);
    class ChatElement extends lit_1.LitElement {
        static get styles() {
            // TODO import other variables from the theme descriptior
            //      also theme variables should be prefixed? e.g. mb-color-...
            return (0, lit_1.css) `
      :host {
        color: var(--mindbreeze-colors-primary);
      }
      h1 {
        color: var(--color-link);
      }
      .chat {
        display:grid;
        height: 100%;
      }
          
    `;
        }
        constructor() {
            super();
            this.isStreaming = false;
            this.conversation = [];
            this.autoScroll = true;
            this.enableCitation = true;
            this.useSearchInput = true;
            this.useUserConstraints = true;
            this.useSourceContextConstraints = true;
            this.initializeFromUserQuery = false;
            this.applyAnswersSettings = true;
            this.showCreateNewConversation = true;
            this.messagesFrameHeight = 0;
            this.enableVoting = false;
            this.restrictToSources = false;
            this.showAiDisclaimer = true;
            this.showScrollButton = false;
            // Template callbacks
            this.onViewCreate = (modelHolder, options) => {
                // console.log("onViewCreate", options);
                if (!this.application) {
                    this.application = options.application || modelHolder.options.application;
                }
                this.setModel(modelHolder.model);
                this.settingsConfig = options === null || options === void 0 ? void 0 : options.settingsConfig;
                if (this.application) {
                    // @ts-ignore
                    this.chatStylingModel = this.application.getThemeProvider().getWidgetStyling("chat");
                    if (this.chatStylingModel) {
                        this.chatStylingModel.on('change', () => {
                            this.widgetStyling = Object.assign({}, this.chatStylingModel.attributes);
                        });
                        this.chatStylingModel.trigger('change');
                    }
                }
                // In workplace the `chatViewEl` is not in dom yet so that the resize handler is not attached to window
                // FIXME: added timeout for workplace
                setTimeout(this.attachResizeHandler.bind(this), 0);
                this.application.execute((app) => {
                    this.intializeChatAfterApplicationInitialized(app);
                });
            };
            this.onViewRemove = () => {
                console.log("onViewRemove");
                this.chatStylingModel.destroy();
            };
            this.handleStopGenerating = this.handleStopGenerating.bind(this);
        }
        initializeConversationIfNeeded() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.initialAssistantMessageI18n) {
                    const locale = i18n_1.default.currentLanguage().split('-')[0].toLowerCase(); // "en-US" → "en"
                    const assistantMessage = this.initialAssistantMessageI18n[locale];
                    if (assistantMessage) {
                        return this.generateFromInput(undefined, this.initialAssistantMessageI18n[locale][0].content);
                    }
                    else {
                        return Promise.reject(`Given locale ${locale} does not provide assistant message.`);
                    }
                }
            });
        }
        intializeChatAfterApplicationInitialized(app) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.initializeConversationIfNeeded();
                if (this.initialUserInput || this.initializeFromUserQuery) {
                    const initialUserInput = this.initialUserInput;
                    const input = this.querySelector("insight-chat-input");
                    const userQuery = app.getUnparsedUserQuery();
                    if (input === null || input === void 0 ? void 0 : input.submitText) {
                        if (initialUserInput) {
                            input.submitText(initialUserInput);
                        }
                        else if (userQuery) {
                            input.submitText(userQuery);
                        }
                    }
                }
            });
        }
        setModel(model) {
            this.model = model;
            if (model) {
                if (this.restrictToSources) {
                    if (!this.model.input.get("source_context.constraints.chat_sources")) {
                        this.model.input.set("source_context.constraints.chat_sources", { "unparsed": "NOT ALL" }, { silent: true });
                    }
                }
            }
        }
        attachResizeHandler() {
            var _a, _b;
            const chatViewEl = this.querySelector("insight-chat-view");
            if (chatViewEl && chatViewEl.shadowRoot) {
                const viewportElement = ((_b = (_a = this.application) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.viewportElement) || this.parentElement;
                this.resizer = new resizer_1.default(chatViewEl, viewportElement, { height: this.height });
                //insight-chat has negative offset
                this.resizer.resize();
                const handleOnResize = () => {
                    this.resizer.resize();
                };
                window.addEventListener("resize", handleOnResize);
                this.scrollContainer = chatViewEl.querySelector('[slot="messages"]');
                if (this.scrollContainer) {
                    this.scrollContainer.addEventListener("scroll", () => {
                        const isAtBottom = this.scrollContainer.scrollTop + this.scrollContainer.clientHeight >=
                            this.scrollContainer.scrollHeight - 2;
                        this.showScrollButton = !isAtBottom;
                    });
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            var _a;
            this.themeDescriptorModel = themeDescriptorModel;
            if (this.themeDescriptorModel && this.application) {
                this.themeDescriptor = (_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes;
                this.themeDescriptorModel.on("change", () => {
                    var _a;
                    this.themeDescriptor = (_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes;
                    this.requestUpdate();
                });
            }
        }
        getConversationMessages() {
            var _a, _b, _c, _d, _e, _f;
            let messages = [];
            for (let pair of this.conversation) {
                if (pair.user) {
                    messages.push({
                        from: "user",
                        content: pair.user.text,
                    });
                }
                if (pair.assistant) {
                    const text = ((_b = (_a = pair.assistant.models) === null || _a === void 0 ? void 0 : _a.answer) === null || _b === void 0 ? void 0 : _b.get("unparsed_generated_text_without_citations")) || ((_d = (_c = pair.assistant.models) === null || _c === void 0 ? void 0 : _c.answer) === null || _d === void 0 ? void 0 : _d.get("unparsed_generated_text"));
                    messages.push({
                        from: "assistant",
                        content: text !== null && text !== void 0 ? text : "",
                    });
                }
            }
            // if the first message is an empty assistant message, remove it -> detects initial assistant message
            if (((_e = messages === null || messages === void 0 ? void 0 : messages[0]) === null || _e === void 0 ? void 0 : _e.from) == "assistant" && !((_f = messages === null || messages === void 0 ? void 0 : messages[0]) === null || _f === void 0 ? void 0 : _f.content)) {
                messages.splice(0, 1);
            }
            return messages;
        }
        requestUpdate(name, oldValue, options) {
            if (name == "application" && oldValue == null && this.application) {
                // console.log("application available, wiring theme descriptor");
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
            super.requestUpdate(name, oldValue, options);
        }
        forceFocusonInput() {
            return this.themeDescriptor.widgets.chat.input.textInput.forceFocus;
        }
        getPipelineSelection(selection, value) {
            let result = {};
            result["pipeline_" + selection] = value;
            return result;
        }
        getBaseGenerateInput() {
            var _a;
            let baseSettings = {};
            if (this.applyAnswersSettings) {
                // in workplace when initalize the touchpoint with initializeUserInput == true then this.settingsConfig is undefined
                const answersSettings = (_a = this.settingsConfig) === null || _a === void 0 ? void 0 : _a.getEffectiveSettingsForTemplate("answers", {});
                if (answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.conversationInputPresetsJson) {
                    let presetsJson = answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.conversationInputPresetsJson;
                    if (typeof presetsJson === "string") {
                        try {
                            presetsJson = JSON.parse(presetsJson);
                        }
                        catch (e) {
                            console.warn("Failed to parse presets", e);
                        }
                    }
                    if (typeof presetsJson !== "object") {
                        console.warn("Failed to apply presetsJson, expected object-obtained", typeof presetsJson);
                    }
                    else {
                        baseSettings = Object.assign({}, presetsJson);
                    }
                }
                if ((answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelection) && (answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelectionValue)) {
                    baseSettings = Object.assign(baseSettings, this.getPipelineSelection(answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelection, answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelectionValue));
                    return baseSettings;
                }
            }
            if (this.pipelineSelection && this.pipelineSelectionValue) {
                baseSettings = Object.assign(baseSettings, this.getPipelineSelection(this.pipelineSelection, this.pipelineSelectionValue));
            }
            else if (this.modelId) {
                baseSettings = Object.assign(baseSettings, this.getPipelineSelection("id", this.modelId));
            }
            return baseSettings;
        }
        generateFromInput(event, generatedText) {
            return __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve, reject) => {
                    this.isStreaming = true;
                    let text;
                    if (event) {
                        text = event === null || event === void 0 ? void 0 : event.detail.text;
                        event.preventDefault();
                    }
                    // console.log("input changes", text);
                    const defaultChannel = getDefaultChannel(this.application);
                    const url = defaultChannel.get("url");
                    const channelOptions = Object.assign({}, this.application.channelOptions || {});
                    channelOptions.application = this.application;
                    const citationIdPrefix = _.uniqueId("cit");
                    const messages = this.getConversationMessages();
                    const channelInfo = { url,
                        channelOptions,
                        prepareRequest: defaultChannel.prepareRequest.bind(defaultChannel) };
                    // TOOD get PipelineSelection as an option
                    const searchModelOptions = {
                        useSearchInput: this.useSearchInput,
                        useUserConstraints: this.useUserConstraints,
                        useSourceContextConstraints: this.useSourceContextConstraints,
                        useSourceContextChatSourcesConstraint: !this.restrictToSources,
                        searchInputIsUserQuery: true
                    };
                    const createRAGPipelineAnswerInputAttributes = this.getBaseGenerateInput();
                    const useInputs = text != null;
                    this.answerModel = (0, answer_1.createRAGPipelineAnswerModel)(Object.assign(Object.assign({}, createRAGPipelineAnswerInputAttributes), {
                        inputs: text,
                        messages: messages,
                        stream: true,
                        retrieval_options: {
                            skip_retrieval: false,
                            search_request: {}, // this shoud be filled in later.
                            use_inputs: useInputs
                        },
                        // generation_options: {
                        //    message_templates: messages
                        //},
                        parameters: {
                            retrieval_details: true,
                        },
                        //TBD: passing settings while create application is too late and
                        // config should be loaded from appfragment schema
                        // we should also distinguish between ai-answer in standalone mode and chat mode
                        citation_options: {
                            enable_citation: this.enableCitation,
                            citationid_prefix: citationIdPrefix
                        }
                    }), { application: this.application, channelInfo }, null, answer_1.SearchModelTriggerStrategyType.None, searchModelOptions);
                    this.answerModel.deactivate();
                    this.answerModel.on("regenerate-answer", this.handleRegenerateAnswerEvent.bind(this));
                    this.answerModel.on("stop-generate-answer", this.handleStopGenerateAnswerEvent.bind(this));
                    this.answerModel.on("computed", () => {
                        // console.log("Answer computed");
                        this.isStreaming = false;
                        if (this.restrictToSources) {
                            this.constrainSearchToAnswerSources(this.answerModel);
                        }
                        resolve();
                    });
                    this.answerModel.on("computing", () => {
                        this.isStreaming = true;
                    });
                    const user = {
                        kind: "user",
                        id: this.conversation.length,
                        text: text,
                    };
                    const assistant = {
                        kind: "assistant",
                        id: this.conversation.length + 1,
                        name: "assistant",
                        type: "basic",
                        models: { answer: this.answerModel },
                        modelDefaults: this.getModelDefaults(),
                        messages,
                        initializedCallback: (app) => {
                            if (this.answerModel.searchModel) {
                                this.answerModel.searchModel.deactivate();
                            }
                            if (generatedText) {
                                this.answerModel.output.load({ "stream_request_status": "streaming_complete", "generated_text": generatedText });
                                this.answerModel.trigger("computed");
                            }
                            else {
                                this.answerModel.activate();
                            }
                        }
                    };
                    // Triggers rerender
                    if (user.text) {
                        this.conversation = [...this.conversation, { id: this.conversation.length, user, assistant }];
                    }
                    else {
                        this.conversation = [...this.conversation, { id: this.conversation.length, assistant }];
                    }
                });
            });
        }
        constrainSearchToAnswerSources(answerModel) {
            var _a;
            const sources = answerModel.get("sources");
            if (!((_a = sources === null || sources === void 0 ? void 0 : sources.results) === null || _a === void 0 ? void 0 : _a.length)) {
                return;
            }
            const newConstraint = this.createSourcesConstraint(answerModel);
            let existingConstraint = this.model.input.get("source_context.constraints.chat_sources");
            if (existingConstraint === null || existingConstraint === void 0 ? void 0 : existingConstraint.unparsed) {
                existingConstraint = null;
            }
            const mergedConstraint = this.mergeSourceConstraints(existingConstraint, newConstraint);
            this.model.input.set("source_context.constraints.chat_sources", mergedConstraint, { silent: true });
            this.model.input.unset("user.query");
        }
        mergeSourceConstraints(existing, incoming) {
            var _a;
            const isPlaceholder = ((_a = existing === null || existing === void 0 ? void 0 : existing.or) === null || _a === void 0 ? void 0 : _a.unparsed) === "NOT ALL";
            const existingOr = (!isPlaceholder && Array.isArray(existing === null || existing === void 0 ? void 0 : existing.or))
                ? existing.or
                : [];
            const incomingOr = Array.isArray(incoming === null || incoming === void 0 ? void 0 : incoming.or) ? incoming.or : [];
            if (existingOr.length === 0 && incomingOr.length === 0) {
                return { or: { unparsed: "NOT ALL" } };
            }
            const merged = [...existingOr];
            const seenIds = new Set();
            for (const entry of existingOr) {
                const id = JSON.stringify(entry === null || entry === void 0 ? void 0 : entry.and);
                seenIds.add(id);
            }
            for (const entry of incomingOr) {
                if (!entry)
                    continue;
                const id = JSON.stringify(entry.and);
                if (seenIds.has(id))
                    continue;
                merged.push(entry);
                seenIds.add(id);
            }
            return { or: merged };
        }
        createSourcesConstraint(answerModel) {
            var _a;
            const sources = answerModel.get("sources");
            const results = (_a = answerModel.get("sources")) === null || _a === void 0 ? void 0 : _a.results;
            if (!Array.isArray(results) || results.length === 0) {
                return { or: [] };
            }
            const constraint = { or: sources === null || sources === void 0 ? void 0 : sources.results.map((resultItem) => {
                    const keys = ["mes:key", "fqcategory"];
                    return { and: keys.map(key => { return { label: key, regex: `^\\Q${resultItem.result[key].value}\\E$` }; }) };
                }) };
            return constraint;
        }
        getModelDefaults() {
            var _a, _b, _c;
            const search = ((_a = this.model) === null || _a === void 0 ? void 0 : _a.getInputAsBaseAttributes)
                ? this.model.getInputAsBaseAttributes()
                : Object.assign({}, (((_c = (_b = this.model) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.attributes) || {}));
            return {
                search: search
            };
        }
        updated(changedProps) {
            super.updated(changedProps);
            requestAnimationFrame(() => {
                var _a;
                const chatViewEl = this.querySelector("insight-chat-view");
                const messagesScroll = (_a = chatViewEl.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.messages-scroll');
                if (messagesScroll) {
                    this.messagesFrameHeight = messagesScroll.offsetHeight;
                    this.style.setProperty('--messages-frame-height', `${this.messagesFrameHeight}px`);
                }
            });
            if (changedProps.has("conversation")) {
                requestAnimationFrame(() => {
                    const container = this.renderRoot.querySelector('[slot="messages"]');
                    if (!container)
                        return;
                    const messages = container.querySelectorAll("insight-chat-message");
                    if (messages.length === 0)
                        return;
                    const lastMessage = messages[messages.length - 1];
                    const targetScrollTop = lastMessage.offsetTop;
                    container.scrollTo({
                        top: targetScrollTop,
                        behavior: "smooth"
                    });
                    // cleanup last Observer
                    if (this.observer) {
                        this.observer.disconnect();
                        this.observer = null;
                    }
                    // create new Observer
                    this.observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (this.conversation.length) {
                                this.showScrollButton = !entry.isIntersecting;
                            }
                            else {
                                this.showScrollButton = false;
                            }
                        });
                    }, { root: container, threshold: 0.1 });
                    this.observer.observe(lastMessage);
                });
            }
        }
        onChatAction(event) {
            var _a;
            if (event.detail.action == "createNewConversation") {
                (_a = this.answerModel) === null || _a === void 0 ? void 0 : _a.abortComputation();
                this.conversation = [];
                let input = this.querySelector("insight-chat-input");
                input.focusTextArea();
            }
        }
        handleStopGenerateAnswerEvent(answerModel) {
            this.answerModel.abortComputation();
            this.isStreaming = false;
        }
        handleRegenerateAnswerEvent(answerModel, app) {
            var _a;
            const conversationChatFoundIdx = this.conversation.findIndex((pair) => { var _a, _b, _c; return ((_c = (_b = (_a = pair === null || pair === void 0 ? void 0 : pair.assistant) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.answer) === null || _c === void 0 ? void 0 : _c.cid) === answerModel.cid; });
            if (conversationChatFoundIdx !== -1) {
                const { user } = this.conversation[conversationChatFoundIdx];
                if (user) {
                    // Get only the lsit of messages before current message
                    const messages = (_a = this.getConversationMessages()) === null || _a === void 0 ? void 0 : _a.slice(0, conversationChatFoundIdx);
                    // TODO
                    // this.generateTextStream(answerModel, user.text, messages, app);
                }
                else {
                    console.error("Failed to regenerate the answer, no user part found.");
                }
            }
            else {
                console.error("Failed to regenerate the answer, no assistent part found.");
            }
        }
        createRenderRoot() {
            return this;
        }
        assistantAppSettings() {
            var _a, _b, _c;
            return {
                "initAction": {
                    settings: {
                        "answers.enableCitation": this.enableCitation,
                        "answers.metadatakeys": this.metadatakeys,
                        "answers.lineLimit": (_c = (_b = (_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.base) === null || _c === void 0 ? void 0 : _c.maxLines,
                        "answers.showQuestion": false
                    }
                },
            };
        }
        renderInsightApp(part) {
            var _a;
            const useAssistantModule = (_a = this.assistantModule) === null || _a === void 0 ? void 0 : _a.split(".");
            const appFragmentJson = {
                name: "chatmessage",
                type: "assistant",
                // TODO: if we use default appfragment data-elable-voting is implisit via chat 
                // Hide AI Disclaimer in Chat mode (already shown below the input field)
                htmlFragment: `<div data-template="answers" data-answer-model="answer" data-show-ai-disclaimer="false" data-enable-voting=${this.enableVoting}></div>`
            };
            const effectiveSettings = this.assistantAppSettings();
            if ((useAssistantModule === null || useAssistantModule === void 0 ? void 0 : useAssistantModule.length) === 2) {
                return (0, lit_1.html) `
      <insight-app
        moduletype=${useAssistantModule[0]}
        modulename=${useAssistantModule[1]}
        .settings=${effectiveSettings}
        .models=${Object.assign({}, part.models)}
        .modelDefaults=${part.modelDefaults}
        .initializedCallback=${part.initializedCallback}
      ></insight-app>
    `;
            }
            return (0, lit_1.html) `
    <insight-app
      .appFragmentJson=${appFragmentJson}
      .settings=${effectiveSettings}
      .models=${Object.assign({}, part.models)}
      .modelDefaults=${part.modelDefaults}
      .initializedCallback=${part.initializedCallback}
    ></insight-app>
  `;
        }
        renderPart(part) {
            var _a, _b, _c, _d;
            // TODO: should we pass icons prop to the insight-chat-message and remove themeDescriptor?
            // const chatTheme = this.themeDescriptor.widgets.chat;
            const chatTheme = this.widgetStyling;
            if (part.kind === "assistant") {
                return (0, lit_1.html) `
        <insight-chat-message role="assistant" .themeDescriptor=${this.themeDescriptor} .messageThemeDescriptor=${(_a = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _a === void 0 ? void 0 : _a['assistant']} .baseMessageThemeDescriptor=${(_b = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _b === void 0 ? void 0 : _b['base']}>
          ${this.renderInsightApp(part)}
        </insight-chat-message>
      `;
            }
            else if (part.kind === "user") {
                return (0, lit_1.html) `
        <insight-chat-message role="user" .themeDescriptor=${this.themeDescriptor} .messageThemeDescriptor=${(_c = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _c === void 0 ? void 0 : _c['user']} .baseMessageThemeDescriptor=${(_d = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _d === void 0 ? void 0 : _d['base']}>
          <div style="white-space: break-spaces;">${part.text}</div>
        </insight-chat-message>
      `;
            }
        }
        // TODO register this per widget so that the application can render that once.
        renderVariables() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87;
            if (!((_b = (_a = this.themeDescriptor) === null || _a === void 0 ? void 0 : _a.widgets) === null || _b === void 0 ? void 0 : _b.chat)) {
                return "";
            }
            // 
            const ApplicationPrefix = (_c = this.application.themeable.prefix) !== null && _c !== void 0 ? _c : '';
            const prefix = "";
            const chatTheme = (_d = this.widgetStyling) !== null && _d !== void 0 ? _d : (_f = (_e = this.themeDescriptor) === null || _e === void 0 ? void 0 : _e.widgets) === null || _f === void 0 ? void 0 : _f.chat;
            const answerTheme = (_h = (_g = this.themeDescriptor) === null || _g === void 0 ? void 0 : _g.widgets) === null || _h === void 0 ? void 0 : _h.answer;
            const assistantBackground = (chatTheme) => {
                var _a, _b, _c, _d;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.assistant) === null || _a === void 0 ? void 0 : _a.backgroundColor) || ((_b = chatTheme.message.assistant) === null || _b === void 0 ? void 0 : _b.background) || ((_c = chatTheme.message.base) === null || _c === void 0 ? void 0 : _c.backgroundColor) || ((_d = chatTheme.message.base) === null || _d === void 0 ? void 0 : _d.background));
            };
            const userInputBackground = (chatTheme) => {
                var _a, _b, _c, _d;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_b = (_a = chatTheme.input) === null || _a === void 0 ? void 0 : _a.textInput) === null || _b === void 0 ? void 0 : _b.backgroundColor) || ((_d = (_c = chatTheme.input) === null || _c === void 0 ? void 0 : _c.textInput) === null || _d === void 0 ? void 0 : _d.background));
            };
            const userBackground = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.user) === null || _a === void 0 ? void 0 : _a.backgroundColor) || ((_b = chatTheme.message.user) === null || _b === void 0 ? void 0 : _b.background));
            };
            const assistantFontFamily = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.assistant) === null || _a === void 0 ? void 0 : _a.fontFamily) || ((_b = chatTheme.message.base) === null || _b === void 0 ? void 0 : _b.fontFamily));
            };
            const userFontFamily = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.user) === null || _a === void 0 ? void 0 : _a.fontFamily) || ((_b = chatTheme.message.base) === null || _b === void 0 ? void 0 : _b.fontFamily));
            };
            return (0, lit_1.html) `
        <style>
           /** The accessibility.js inject this css class to body on input focus, to avoid setting unwanted focus style we override*/
           .mb-highlight-focus insight-chat-input:focus {
              box-shadow: none !important;
              outline: none !important;
              -webkit-box-shadow: none !important;
           }
           insight-chat {
            --insight-chat-message-gap: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_k = (_j = chatTheme.message) === null || _j === void 0 ? void 0 : _j.base) === null || _k === void 0 ? void 0 : _k.messageGap)};
            --insight-chat-message-citation-link-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_o = (_m = (_l = chatTheme.message.base) === null || _l === void 0 ? void 0 : _l.citation) === null || _m === void 0 ? void 0 : _m.link) === null || _o === void 0 ? void 0 : _o.color)};
            --insight-chat-header-padding: ${chatTheme.header.isFullWidth ? chatTheme.header.paddingTop : 0};

            --insight-chat-ai-disclaimer-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_p = chatTheme.aiDisclaimer) === null || _p === void 0 ? void 0 : _p.color)};
            --insight-chat-ai-disclaimer-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.aiDisclaimer.fontSize)};
            --insight-chat-ai-disclaimer-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.aiDisclaimer.fontFamily)};
           }

           insight-chat-actions {
            --insight-chat-actions-button-passive-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.passiveColor)};
            --insight-chat-actions-button-clicked-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.clickedColor)};
            --insight-chat-actions-button-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.border.color)};
           }
           insight-chat-message{
            --insight-chat-code-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_r = (_q = chatTheme.message.base) === null || _q === void 0 ? void 0 : _q.code) === null || _r === void 0 ? void 0 : _r.color)};
            --insight-chat-code-background-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_t = (_s = chatTheme.message.base) === null || _s === void 0 ? void 0 : _s.code) === null || _t === void 0 ? void 0 : _t.backgroundColor)};
            --insight-chat-code-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_w = (_v = (_u = chatTheme.message.base) === null || _u === void 0 ? void 0 : _u.code) === null || _v === void 0 ? void 0 : _v.border) === null || _w === void 0 ? void 0 : _w.color)};
            --insight-chat-code-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_z = (_y = (_x = chatTheme.message.base) === null || _x === void 0 ? void 0 : _x.code) === null || _y === void 0 ? void 0 : _y.border) === null || _z === void 0 ? void 0 : _z.width)};
            --insight-chat-code-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_2 = (_1 = (_0 = chatTheme.message.base) === null || _0 === void 0 ? void 0 : _0.code) === null || _1 === void 0 ? void 0 : _1.border) === null || _2 === void 0 ? void 0 : _2.style)};
            --insight-chat-code-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_5 = (_4 = (_3 = chatTheme.message.base) === null || _3 === void 0 ? void 0 : _3.code) === null || _4 === void 0 ? void 0 : _4.border) === null || _5 === void 0 ? void 0 : _5.radius)};
            
            --insight-answer-feedback-background-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_6 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _6 === void 0 ? void 0 : _6.backgroundColor)};
            --insight-answer-feedback-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_8 = (_7 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _7 === void 0 ? void 0 : _7.border) === null || _8 === void 0 ? void 0 : _8.width)};
            --insight-answer-feedback-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_10 = (_9 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _9 === void 0 ? void 0 : _9.border) === null || _10 === void 0 ? void 0 : _10.style)};
            --insight-answer-feedback-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_12 = (_11 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _11 === void 0 ? void 0 : _11.border) === null || _12 === void 0 ? void 0 : _12.color)};
            --insight-answer-feedback-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_14 = (_13 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _13 === void 0 ? void 0 : _13.border) === null || _14 === void 0 ? void 0 : _14.radius)};
            --insight-answer-feedback-input-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_16 = (_15 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _15 === void 0 ? void 0 : _15.input) === null || _16 === void 0 ? void 0 : _16.color)};
            --insight-answer-feedback-input-background: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_18 = (_17 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _17 === void 0 ? void 0 : _17.input) === null || _18 === void 0 ? void 0 : _18.backgroundColor)};
            --insight-answer-feedback-input-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_21 = (_20 = (_19 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _19 === void 0 ? void 0 : _19.input) === null || _20 === void 0 ? void 0 : _20.border) === null || _21 === void 0 ? void 0 : _21.width)};
            --insight-answer-feedback-input-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_24 = (_23 = (_22 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _22 === void 0 ? void 0 : _22.input) === null || _23 === void 0 ? void 0 : _23.border) === null || _24 === void 0 ? void 0 : _24.color)};
            --insight-answer-feedback-input-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_27 = (_26 = (_25 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _25 === void 0 ? void 0 : _25.input) === null || _26 === void 0 ? void 0 : _26.border) === null || _27 === void 0 ? void 0 : _27.style)};
            --insight-answer-feedback-input-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_30 = (_29 = (_28 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _28 === void 0 ? void 0 : _28.input) === null || _29 === void 0 ? void 0 : _29.border) === null || _30 === void 0 ? void 0 : _30.radius)};
            --insight-answer-feedback-submit-background: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_32 = (_31 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _31 === void 0 ? void 0 : _31.submit) === null || _32 === void 0 ? void 0 : _32.backgroundColor)};
            --insight-answer-feedback-submit-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_35 = (_34 = (_33 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _33 === void 0 ? void 0 : _33.submit) === null || _34 === void 0 ? void 0 : _34.border) === null || _35 === void 0 ? void 0 : _35.width)};
            --insight-answer-feedback-submit-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_38 = (_37 = (_36 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _36 === void 0 ? void 0 : _36.submit) === null || _37 === void 0 ? void 0 : _37.border) === null || _38 === void 0 ? void 0 : _38.color)};
            --insight-answer-feedback-submit-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_41 = (_40 = (_39 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _39 === void 0 ? void 0 : _39.submit) === null || _40 === void 0 ? void 0 : _40.border) === null || _41 === void 0 ? void 0 : _41.style)};
            --insight-answer-feedback-submit-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_44 = (_43 = (_42 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _42 === void 0 ? void 0 : _42.submit) === null || _43 === void 0 ? void 0 : _43.border) === null || _44 === void 0 ? void 0 : _44.radius)};
            --insight-answer-feedback-submit-text-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_46 = (_45 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _45 === void 0 ? void 0 : _45.submit) === null || _46 === void 0 ? void 0 : _46.color)};
            --insight-answer-feedback-chip-background: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_48 = (_47 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _47 === void 0 ? void 0 : _47.chip) === null || _48 === void 0 ? void 0 : _48.backgroundColor)};
            --insight-answer-feedback-chip-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_51 = (_50 = (_49 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _49 === void 0 ? void 0 : _49.chip) === null || _50 === void 0 ? void 0 : _50.border) === null || _51 === void 0 ? void 0 : _51.width)};
            --insight-answer-feedback-chip-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_54 = (_53 = (_52 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _52 === void 0 ? void 0 : _52.chip) === null || _53 === void 0 ? void 0 : _53.border) === null || _54 === void 0 ? void 0 : _54.color)};
            --insight-answer-feedback-chip-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_57 = (_56 = (_55 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _55 === void 0 ? void 0 : _55.chip) === null || _56 === void 0 ? void 0 : _56.border) === null || _57 === void 0 ? void 0 : _57.style)};
            --insight-answer-feedback-chip-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_60 = (_59 = (_58 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _58 === void 0 ? void 0 : _58.chip) === null || _59 === void 0 ? void 0 : _59.border) === null || _60 === void 0 ? void 0 : _60.radius)};
            --insight-answer-feedback-chip-text-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_62 = (_61 = answerTheme === null || answerTheme === void 0 ? void 0 : answerTheme.feedback) === null || _61 === void 0 ? void 0 : _61.chip) === null || _62 === void 0 ? void 0 : _62.color)};

           }
           insight-chat-message[role=user] {
            --insight-chat-message-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.color)};
            --insight-chat-message-avatar-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarColor)}; 
            --insight-chat-message-background: ${userBackground(chatTheme)};
            /** TBD this values for user-message border properties are not falling back to base  */
            --insight-chat-message-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderWidth)};
            --insight-chat-message-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderColor)};
            --insight-chat-message-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderStyle)};
            --insight-chat-message-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderRadius)};
            --insight-chat-message-avatar-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarWidth)};
            --insight-chat-message-avatar-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarHeight)};
            --insight-chat-message-font-family: ${userFontFamily(chatTheme)};
            --insight-chat-message-bubble-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.maxBubbleWidth)};
            --insight-chat-message-bubble-min-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.minBubbleWidth)};
            --insight-chat-message-bubble-padding: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.bubblePadding)};
           }

           insight-chat-message[role=assistant] {
            --insight-chat-message-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.color)};
            --insight-chat-message-avatar-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarColor)};
            --insight-chat-message-background: ${assistantBackground(chatTheme)};
            --insight-chat-message-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderWidth)};
            --insight-chat-message-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderColor)};
            --insight-chat-message-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderStyle)};
            --insight-chat-message-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderRadius)};
            --insight-chat-message-font-family: ${assistantFontFamily(chatTheme)};
            --insight-chat-message-bubble-padding: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.bubblePadding)};
            --insight-chat-message-bubble-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.maxBubbleWidth)};
            --insight-chat-message-bubble-min-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.minBubbleWidth)};
            ${chatTheme.message.assistant.avatarWidth && `--insight-chat-message-avatar-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarWidth)};`};
            ${chatTheme.message.assistant.avatarHeight && `--insight-chat-message-avatar-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarHeight)};`};
           }

           insight-chat-input {
            --insight-chat-input-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_64 = (_63 = chatTheme.input) === null || _63 === void 0 ? void 0 : _63.textInput) === null || _64 === void 0 ? void 0 : _64.color)};
            --insight-chat-input-background: ${userInputBackground(chatTheme)};
            --insight-chat-input-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_66 = (_65 = chatTheme.input) === null || _65 === void 0 ? void 0 : _65.textInput) === null || _66 === void 0 ? void 0 : _66.borderRadius)};
            --insight-chat-input-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_68 = (_67 = chatTheme.input) === null || _67 === void 0 ? void 0 : _67.textInput) === null || _68 === void 0 ? void 0 : _68.fontFamily)};
            --insight-chat-input-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_70 = (_69 = chatTheme.input) === null || _69 === void 0 ? void 0 : _69.textInput) === null || _70 === void 0 ? void 0 : _70.maxInputWidth)};
            --insight-chat-input-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_73 = (_72 = (_71 = chatTheme.input) === null || _71 === void 0 ? void 0 : _71.textInput) === null || _72 === void 0 ? void 0 : _72.border) === null || _73 === void 0 ? void 0 : _73.width)};
            --insight-chat-input-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_76 = (_75 = (_74 = chatTheme.input) === null || _74 === void 0 ? void 0 : _74.textInput) === null || _75 === void 0 ? void 0 : _75.border) === null || _76 === void 0 ? void 0 : _76.color)};
            --insight-chat-input-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_79 = (_78 = (_77 = chatTheme.input) === null || _77 === void 0 ? void 0 : _77.textInput) === null || _78 === void 0 ? void 0 : _78.border) === null || _79 === void 0 ? void 0 : _79.style)};
            ${((_81 = (_80 = chatTheme.input) === null || _80 === void 0 ? void 0 : _80.textInput) === null || _81 === void 0 ? void 0 : _81.border)
                ? `
                  --insight-chat-input-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.color)};
                  --insight-chat-input-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.width)};
                  --insight-chat-input-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.style)};
                `
                : ''};
            ${((_83 = (_82 = chatTheme.input) === null || _82 === void 0 ? void 0 : _82.textInput) === null || _83 === void 0 ? void 0 : _83.focus) && ((_85 = (_84 = chatTheme.input) === null || _84 === void 0 ? void 0 : _84.textInput) === null || _85 === void 0 ? void 0 : _85.focus.border)
                ? `
                  --insight-chat-input-border-focus-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.color)};
                  --insight-chat-input-border-focus-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.width)};
                  --insight-chat-input-border-focus-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.style)};
                `
                : ''};
            --insight-chat-input-boxshadow: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_87 = (_86 = chatTheme.input) === null || _86 === void 0 ? void 0 : _86.textInput) === null || _87 === void 0 ? void 0 : _87.boxShadow)};
           }
           insight-app {
              display: block;
              min-width: 0;
              max-width: 100%;
           }
           insight-app > .mb-flexbox{
              flex-grow:1;
           }
           insight-app code{
              width: 100%;
              display: block;
              overflow-x: auto;
              background: #f9f9f9;
              background: var(--insight-chat-code-background-color);
              color:var(--insight-chat-code-color);
              box-sizing: border-box;
              border-color: var(--insight-chat-code-border-color);
              border-width: var(--insight-chat-code-border-width);
              border-style: var(--insight-chat-code-border-style);
              border-radius: var(--insight-chat-code-border-radius);
              padding: 15px;
              margin: 10px 0;
           }
           insight-app pre{
              border: none !important;
              padding: unset !important;
              margin: unset !important;
              box-sizing: border-box;
           }
           insight-chat {
             position: relative;
           }
          insight-chat-view .mb-answers-container .mb-answer-header {
            display:none;
          }
          insight-chat-view .mb-answers-container .mb-answer-item {
            border: none !important;
          }
        
          insight-chat-view .mb-answers-container .mb-action-stop-generating,
          insight-chat-view.isStreaming .mb-answers-container .mb-action-regenerate-answer{
            display:none !important;
          }

          insight-chat-view .mb-answers-container .mb-answer{
            padding:16px 20px;
          }
          insight-chat-view .mb-answers-container .generated-answer-text,
          insight-chat-view .mb-answers-container .mb-answer-item:first-child .mb-answer
          {
            padding:0;
          }
          insight-chat-view .mb-answers-container a[href^="#block-citation-id="]{
            color: var(--insight-chat-message-citation-link-color);
          }
          insight-chat-view .mb-answers-container{
            background: var(--message-background) !important;;
            border-radius: var(--message-border-radius) !important;;
            border-width: var(--message-border-width) !important;;
            border-color: var(--message-border-color) !important;;
            border-style: var(--message-border-style) !important;;
            font-family:  var(--message-font-family) !important;;
            margin:0 !important;
            max-width: unset!important;;
            border-left: ${!chatTheme.message.assistant.hideLeftAccentBorder ? `3px solid var(--${ApplicationPrefix ? `${ApplicationPrefix}-` : ''}colors-secondary)` : "none"} !important;
          }
            .message-list{
              display:flex; 
              flex-direction: column;
              margin-bottom:10px;
              scrollbar-gutter: stable;
              flex-grow:1;
              overflow-y: auto;
            }

            /* width */
            .message-list::-webkit-scrollbar {
              width: 5px;
            }

            /* Track */
            .message-list::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius:10px;
            }

            /* Handle */
            .message-list::-webkit-scrollbar-thumb {
              background: #888;
            }

            .qa-wrapper{
              display: flex;
              flex-direction: column;
              gap: var(--insight-chat-message-gap);
              padding:10px;
            }
            .qa-wrapper:last-child{
              ${chatTheme.showMessageOnTop ? `min-height:calc(var(--messages-frame-height) - 30px);` : "auto"};
            }
          .scroll-bottom{
            width:40px;
            height:40px;
            border-radius:50%;
            border:none;
            position: absolute; 
            bottom: 60px; 
            right: 20px;
            display:flex;
            justify-content: center;
            align-items: center;
            padding: 0;
          }
          .scroll-bottom .mb-icon {
            width:100%;
            height: auto;
          }

          .ai-disclaimer {
            text-align: center;
            padding-top: 5px;
            padding-bottom: 5px;     
          }

          .ai-disclaimer span {
            font-size: var(--insight-chat-ai-disclaimer-font-size);
            font-family: var(--insight-chat-ai-disclaimer-font-family);
            color: var(--insight-chat-ai-disclaimer-color);
          }

        </style>
    `;
        }
        renderTurn(turn) {
            return (0, lit_1.html) `
      <div class="qa-wrapper">
        ${turn.user ? this.renderPart(turn.user) : lit_1.nothing}
        ${this.renderPart(turn.assistant)}
      </div>
    `;
        }
        handleStopGenerating() {
            this === null || this === void 0 ? void 0 : this.answerModel.trigger('stop-generate-answer', this === null || this === void 0 ? void 0 : this.answerModel);
        }
        renderScrollToBottomIcon() {
            const key = 'scroll-to-bottom-icon';
            const icons = this.themeDescriptor['icons'];
            return (0, utils_1.renderIcon)(icons, key, { altText: (0, i18n_1.default)('icon') });
        }
        getDisclaimerText() {
            var _a, _b;
            if (this.aiDisclaimerText) {
                if ((_a = this.aiDisclaimerText) === null || _a === void 0 ? void 0 : _a.startsWith('i18n.')) {
                    return (0, i18n_1.default)((_b = this.aiDisclaimerText) === null || _b === void 0 ? void 0 : _b.replace('i18n.', ''));
                }
                return this.aiDisclaimerText;
            }
            return (0, i18n_1.default)('ai_chat_ai_disclaimer_text');
        }
        render() {
            var _a, _b, _c;
            //TODO: Selecting Modes
            const chatTheme = this.widgetStyling;
            const showScrollToBottom = (_a = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.showScrollToBottom) !== null && _a !== void 0 ? _a : false;
            const isFullWidth = (_b = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.header) === null || _b === void 0 ? void 0 : _b.isFullWidth;
            return (0, lit_1.html) `
      ${this.renderVariables()}
      <insight-chat-view class=${this.isStreaming ? "isStreaming" : ""}>
      <div slot="actions">
        <insight-chat-actions 
          class="${(0, class_map_js_1.classMap)({ "chat-action-container": true, "full-width": isFullWidth })}" 
          @action=${this.onChatAction} 
          .displayCreateConv=${!(((_c = this.conversation) === null || _c === void 0 ? void 0 : _c.length) == 0) && this.showCreateNewConversation} 
          .themeDescriptor=${this.themeDescriptor} 
          .chatWidgetStyling=${chatTheme}
        >
        </insight-chat-actions>
      </div>
      <div slot="messages" class="message-list">
      ${(0, repeat_js_1.repeat)(this.conversation, (part) => part.id, (part) => this.renderTurn(part))}
      </div>
      <div slot="input">
        <insight-chat-input
          @userinput=${this.generateFromInput}
          .isStreaming=${this.isStreaming}
          .forceFocus=${this.forceFocusonInput()}
          .icons=${this.themeDescriptor['icons']}
          .handleStopGenerating = ${this.handleStopGenerating}
        ></insight-chat-input>

        ${this.showAiDisclaimer ?
                (0, lit_1.html) `
            <div class="ai-disclaimer">
              <span> ${this.getDisclaimerText()} </span>
            </div>
          `
                : lit_1.nothing}
        

         ${this.showScrollButton && showScrollToBottom
                ? (0, lit_1.html) `<button
            class="scroll-bottom"
            @click=${() => {
                    const container = this.querySelector('[slot="messages"]');
                    if (container)
                        container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
                }}
          >
            ${this.renderScrollToBottomIcon()}
          </button>`
                : null}
      </div>
      </insight-chat-view>
     
    `;
        }
    }
    exports.ChatElement = ChatElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_c = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _c : Object)
    ], ChatElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_d = typeof Partial !== "undefined" && Partial) === "function" ? _d : Object)
    ], ChatElement.prototype, "themeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "isStreaming", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "conversation", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_e = typeof Partial !== "undefined" && Partial) === "function" ? _e : Object)
    ], ChatElement.prototype, "widgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "autoScroll", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Number)
    ], ChatElement.prototype, "maxLines", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "modelid" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "modelId", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "height" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "height", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "pipeline-selection" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "pipelineSelection", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "pipeline-selection-value" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "pipelineSelectionValue", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "metadatakeys" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "metadatakeys", void 0);
    __decorate([
        booleanProperty({ attribute: "enable-citation" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "enableCitation", void 0);
    __decorate([
        booleanProperty({ attribute: "use-search-input" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useSearchInput", void 0);
    __decorate([
        booleanProperty({ attribute: "use-user-constraints" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useUserConstraints", void 0);
    __decorate([
        booleanProperty({ attribute: "use-source-context-constraints" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useSourceContextConstraints", void 0);
    __decorate([
        booleanProperty({ attribute: "initialize-from-user-query" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "initializeFromUserQuery", void 0);
    __decorate([
        booleanProperty({ attribute: "apply-answers-settings" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "applyAnswersSettings", void 0);
    __decorate([
        booleanProperty({ attribute: "show-create-new-conversation" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "showCreateNewConversation", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "initial-user-input" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "initialUserInput", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "initial-assistant-message-i18n", converter: exports.objConverter }),
        __metadata("design:type", typeof (_f = typeof Mindbreeze !== "undefined" && Mindbreeze.i18nMessages) === "function" ? _f : Object)
    ], ChatElement.prototype, "initialAssistantMessageI18n", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "assistant-module" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "assistantModule", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "messagesFrameHeight", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_g = typeof ComputedModel !== "undefined" && ComputedModel) === "function" ? _g : Object)
    ], ChatElement.prototype, "model", void 0);
    __decorate([
        booleanProperty({ attribute: "enable-voting" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "enableVoting", void 0);
    __decorate([
        booleanProperty({ attribute: "restrict-to-sources" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "restrictToSources", void 0);
    __decorate([
        booleanProperty({ attribute: "show-ai-disclaimer" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "showAiDisclaimer", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "ai-disclaimer-text" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "aiDisclaimerText", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "showScrollButton", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "onViewCreate", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "onViewRemove", void 0);
    // TODO check if this is already the case.
    custom_element_registry_1.customElementRegistry.register("insight-chat", ChatElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-view", ChatViewElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-input", chat_userinput_1.ChatInputElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-actions", ChatActionsElement);
    custom_element_registry_1.customElementRegistry.register("insight-app", app_1.AppElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-message", chat_message_1.InsightChatMessage);
});
